var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal } from '../../common/Modal';
import regEx from '../../../utils/regex';
import { ZeroToNull } from '../../../utils/utils';
import { refetchSafesPageQuery, useCreateSafeTermMutation, ValuationBasis, } from '../../../__generated__/graphql';
import { useParams } from 'react-router';
import { List, ListItemInput, ListItemPercentInput, ListItemSelect, ListItemCurrencyInput, } from '@bootstraplabs/bsw-common-react';
export default function CreateSafeTermModal(props) {
    var _this = this;
    // Router
    var organizationId = useParams().organizationId;
    // State
    var _a = useState(''), name = _a[0], setName = _a[1];
    var _b = useState(''), discount = _b[0], setDiscount = _b[1];
    var _c = useState(ValuationBasis.POST_MONEY), valuationBasis = _c[0], setValuationBasis = _c[1];
    var _d = useState(''), valuationCap = _d[0], setValuationCap = _d[1];
    // GraphQL mutation
    var createSafeTerm = useCreateSafeTermMutation({
        variables: {
            input: {
                organizationId: organizationId,
                name: name.trim(),
                discount: Number(discount),
                valuationBasis: valuationBasis,
                valuationCap: ZeroToNull(Number(valuationCap)),
            },
        },
        refetchQueries: [refetchSafesPageQuery({ organizationId: organizationId })],
    })[0];
    // Helpers
    var ValuationBasisDisplayName;
    (function (ValuationBasisDisplayName) {
        ValuationBasisDisplayName["PRE_MONEY"] = "Pre-money";
        ValuationBasisDisplayName["POST_MONEY"] = "Post-money";
    })(ValuationBasisDisplayName || (ValuationBasisDisplayName = {}));
    var valuationBasisOptions = Object.keys(ValuationBasis).map(function (k) { return ({
        id: ValuationBasis[k],
        name: ValuationBasisDisplayName[k],
    }); });
    var disabled = !name ||
        (name && regEx.trimmedString.test(name.trim())) === false ||
        name.trim().length < 1 ||
        name.trim().length > 100 ||
        Number(discount) < 0 ||
        Number(discount) > 100 ||
        !valuationBasis ||
        Number(valuationCap) < 0 ||
        Number(valuationCap) > 1000000000000;
    var confirm = function () { return __awaiter(_this, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    r = createSafeTerm();
                    setName('');
                    setDiscount('');
                    setValuationCap('');
                    props.onCancel();
                    return [4 /*yield*/, r];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var cancel = function () {
        setName('');
        setDiscount('');
        setValuationCap('');
        props.onCancel();
    };
    return (_jsx(Modal, __assign({ "data-test": "modal-create-safe-term", title: "Create SAFE Term", open: props.open, onCancel: cancel, onConfirm: confirm, disabled: disabled }, { children: _jsxs(List, { children: [_jsx(ListItemInput, { labelWidth: 140, type: "text", label: "Name", value: name, onChange: setName, placeholder: "Series Seed" }, void 0),
                _jsx(ListItemPercentInput, { labelWidth: 140, label: "Discount", value: discount, onChange: setDiscount, placeholder: "20%" }, void 0),
                _jsx(ListItemSelect, { labelWidth: 140, label: "Valuation Basis", value: valuationBasis, onChange: function (val) { return setValuationBasis(val); }, options: valuationBasisOptions }, void 0),
                _jsx(ListItemCurrencyInput, { labelWidth: 140, label: "Valuation Cap", value: valuationCap, onChange: setValuationCap, placeholder: "USD 5,000,000", description: "Valuation cap USD", feedback: Number(valuationCap) < 0
                        ? "Valuation cap must be a positive number"
                        : undefined, feedbackType: "warn" }, void 0)] }, void 0) }), void 0));
}
//# sourceMappingURL=CreateSafeTermModal.js.map